// Auto-generated static-only route metadata for lightweight client bundle
const staticMetaDescriptions = {
  "/": {
    "title": "MH Cockpit | Pilot Training & top UGC Aviation College in India",
    "description": "MH Cockpit offers CPL and pilot training alongside BSc, BBA, and MBA Aviation at top UGC-approved Aviation colleges across India. DGCA-aligned curriculum.",
    "keywords": "aviation college, pilot training, aviation courses, best aviation college, CPL training, UGC approved aviation colleges",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com",
    "ogTitle": "MH Cockpit | Pilot Training & top UGC Aviation College in India",
    "ogDescription": "MH Cockpit offers CPL and pilot training alongside BSc, BBA, and MBA Aviation at top UGC-approved Aviation colleges across India.",
    "ogUrl": "https://mhcockpit.com",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 2880,
    "ogImageHeight": 1621,
    "twitterCard": "summary_large_image",
    "twitterTitle": "MH Cockpit | Pilot Training & top UGC Aviation College in India",
    "twitterDescription": "MH Cockpit offers CPL and pilot training alongside BSc, BBA, and MBA Aviation at top UGC-approved Aviation colleges across India.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/training": {
    "title": "MH Cockpit | Aviation Courses After 12th - Pilot & Degrees",
    "description": "MH Cockpit offers DGCA-aligned CPL training, BSc, BBA, and MBA Aviation degree courses across top UGC-approved colleges in India.",
    "keywords": "Aviation courses after 12th, pilot training, BSc Aviation, BBA Aviation, MBA Aviation, CPL training, DGCA approved courses",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training",
    "ogTitle": "MH Cockpit | Aviation Courses After 12th - Pilot & Degrees",
    "ogDescription": "MH Cockpit offers DGCA-aligned CPL training, BSc, BBA, and MBA Aviation degree courses across top UGC-approved colleges in India.",
    "ogUrl": "https://mhcockpit.com/training",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/commercial-pilot-license.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "MH Cockpit | Aviation Courses After 12th - Pilot & Degrees",
    "twitterDescription": "MH Cockpit offers DGCA-aligned CPL training, BSc, BBA, and MBA Aviation degree courses across India.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/commercial-pilot-license.webp"
  },
  "/training/private-pilot-license": {
    "title": "Private Pilot Licence Ground Classes in India | MH Cockpit",
    "description": "MH Cockpit offers DGCA PPL ground classes for Private Pilot Licence in India - PPL theory, navigation, meteorology, air regulations, and exam coaching.",
    "keywords": "Private Pilot License, PPL ground classes, DGCA PPL, PPL theory, navigation training, meteorology, air regulations, pilot exam coaching",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/private-pilot-license",
    "ogTitle": "Private Pilot Licence Ground Classes in India | MH Cockpit",
    "ogDescription": "MH Cockpit offers DGCA PPL ground classes for Private Pilot Licence in India - PPL theory, navigation, meteorology, air regulations, and exam coaching.",
    "ogUrl": "https://mhcockpit.com/training/private-pilot-license",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/private-pilot-license.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Private Pilot Licence Ground Classes in India | MH Cockpit",
    "twitterDescription": "MH Cockpit offers DGCA PPL ground classes for Private Pilot Licence in India - PPL theory, navigation, meteorology, air regulations, and exam coaching.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/private-pilot-license.webp"
  },
  "/training/commercial-pilot-license": {
    "title": "Commercial Pilot Licence Ground Classes in India | MH Cockpit",
    "description": "MH Cockpit offers DGCA CPL ground classes in India, covering theory, navigation, meteorology, and air regulation - next step after PPL is to fly commercially.",
    "keywords": "Commercial Pilot License, CPL ground classes, DGCA CPL, CPL theory, navigation training, meteorology, air regulations, commercial pilot training",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/commercial-pilot-license",
    "ogTitle": "Commercial Pilot Licence Ground Classes in India | MH Cockpit",
    "ogDescription": "MH Cockpit offers DGCA CPL ground classes in India, covering theory, navigation, meteorology, and air regulation - next step after PPL is to fly commercially.",
    "ogUrl": "https://mhcockpit.com/training/commercial-pilot-license",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/commercial-pilot-license.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Commercial Pilot Licence Ground Classes in India | MH Cockpit",
    "twitterDescription": "MH Cockpit offers DGCA CPL ground classes in India, covering theory, navigation, meteorology, and air regulation.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/commercial-pilot-license.webp"
  },
  "/training/type-rating": {
    "title": "Aircraft Type Rating Ground Classes in India | MH Cockpit",
    "description": "MH Cockpit offers type rating ground classes for CPL holders in India - Boeing and Airbus. DGCA-aligned preparation for airline operations.",
    "keywords": "Type rating, aircraft type rating, Boeing type rating, Airbus type rating, CPL holders, DGCA type rating, airline operations training",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/type-rating",
    "ogTitle": "Aircraft Type Rating Ground Classes in India | MH Cockpit",
    "ogDescription": "MH Cockpit offers type rating ground classes for CPL holders in India - Boeing and Airbus. DGCA-aligned preparation for airline operations.",
    "ogUrl": "https://mhcockpit.com/training/type-rating",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/type-rating.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aircraft Type Rating Ground Classes in India | MH Cockpit",
    "twitterDescription": "MH Cockpit offers type rating ground classes for CPL holders in India - Boeing and Airbus. DGCA-aligned preparation for airline operations.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/type-rating.webp"
  },
  "/training/airline-transport-pilot-license": {
    "title": "Airline Transport Pilot Licence Ground Classes | MH Cockpit",
    "description": "MH Cockpit offers DGCA ATPL ground classes in India - advanced navigation, meteorology, air law, and technical subjects for aspiring airline captains.",
    "keywords": "ATPL, Airline Transport Pilot License, ATPL ground classes, DGCA ATPL, advanced navigation, air law, technical subjects, airline captains",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/airline-transport-pilot-license",
    "ogTitle": "Airline Transport Pilot Licence Ground Classes | MH Cockpit",
    "ogDescription": "MH Cockpit offers DGCA ATPL ground classes in India - advanced navigation, meteorology, air law, and technical subjects for aspiring airline captains.",
    "ogUrl": "https://mhcockpit.com/training/airline-transport-pilot-license",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/aviation-ground-classes.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Airline Transport Pilot Licence Ground Classes | MH Cockpit",
    "twitterDescription": "MH Cockpit offers DGCA ATPL ground classes in India - advanced navigation, meteorology, air law, and technical subjects.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/aviation-ground-classes.webp"
  },
  "/training/dgca-license-conversion": {
    "title": "DGCA Pilot Licence Conversion in India | MH Cockpit",
    "description": "Complete requirements for DGCA licence conversion in India - flying tests, theory exams, Class I medical, RTR(A) licence, and application fee details.",
    "keywords": "DGCA license conversion, pilot licence conversion, flying tests, theory exams, Class I medical, RTR(A) licence, DGCA conversion fees",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/dgca-license-conversion",
    "ogTitle": "DGCA Pilot Licence Conversion in India | MH Cockpit",
    "ogDescription": "Complete requirements for DGCA licence conversion in India - flying tests, theory exams, Class I medical, RTR(A) licence, and application fee details.",
    "ogUrl": "https://mhcockpit.com/training/dgca-license-conversion",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/dgca-license-conversion.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "DGCA Pilot Licence Conversion in India | MH Cockpit",
    "twitterDescription": "Complete requirements for DGCA licence conversion in India - flying tests, theory exams, Class I medical, RTR(A) licence, and application fee details.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/dgca-license-conversion.webp"
  },
  "/training/dgca-medical-requirements": {
    "title": "DGCA Medical Requirements for Pilots in India | MH Cockpit",
    "description": "Understand DGCA medical requirements for pilots in India. MH Cockpit guides you on Class 1 and Class 2 fitness standards and approved medical centres.",
    "keywords": "DGCA medical requirements, Class 1 medical, Class 2 medical, pilot fitness standards, DGCA approved medical centres, pilot medical tests",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/dgca-medical-requirements",
    "ogTitle": "DGCA Medical Requirements for Pilots in India | MH Cockpit",
    "ogDescription": "Understand DGCA medical requirements for pilots in India. MH Cockpit guides you on Class 1 and Class 2 fitness standards and approved medical centres.",
    "ogUrl": "https://mhcockpit.com/training/dgca-medical-requirements",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/dgca-medical-requirements.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "DGCA Medical Requirements for Pilots in India | MH Cockpit",
    "twitterDescription": "Understand DGCA medical requirements for pilots in India. MH Cockpit guides you on Class 1 and Class 2 fitness standards.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/dgca-medical-requirements.webp"
  },
  "/training/dgca-pilot-computer-number": {
    "title": "DGCA Computer Number - How to Apply | MH Cockpit",
    "description": "Learn what is DGCA Computer Number (CN) is and how to apply for one in India - a mandatory step before appearing for DGCA pilot licence exams.",
    "keywords": "DGCA Computer Number, DGCA CN, computer number application, DGCA pilot exams, mandatory DGCA requirement, pilot licence exam",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/dgca-pilot-computer-number",
    "ogTitle": "DGCA Computer Number - How to Apply | MH Cockpit",
    "ogDescription": "Learn what is DGCA Computer Number (CN) is and how to apply for one in India - a mandatory step before appearing for DGCA pilot licence exams.",
    "ogUrl": "https://mhcockpit.com/training/dgca-pilot-computer-number",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/dgca-pilot-computer-number.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "DGCA Computer Number - How to Apply | MH Cockpit",
    "twitterDescription": "Learn what is DGCA Computer Number (CN) is and how to apply for one in India - a mandatory step before appearing for DGCA pilot licence exams.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/dgca-pilot-computer-number.webp"
  },
  "/training/electronic-personnel-license-epl": {
    "title": "DGCA Electronic Personnel Licence (EPL) India | MH Cockpit",
    "description": "DGCA Electronic Personnel Licence replaces physical licences with a digital format via eGCA. Discover what EPL means for your aviation career in India.",
    "keywords": "DGCA EPL, Electronic Personnel Licence India, eGCA pilot licence, digital pilot licence India, DGCA electronic licensing, EPL pilot India, eGCA mobile app aviation, CPL digital licence DGCA, ATPL digital licence India, FRTOL digital licence, pilot credentials eGCA, DGCA digital licensing initiative, electronic aviation licence India, EPL DGCA, pilot licence digital India",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/electronic-personnel-license-epl",
    "ogTitle": "DGCA Electronic Personnel Licence (EPL) India | MH Cockpit",
    "ogDescription": "DGCA Electronic Personnel Licence replaces physical licences with a digital format via eGCA. Discover what EPL means for your aviation career in India.",
    "ogUrl": "https://mhcockpit.com/training/electronic-personnel-license-epl",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/DGCA%20Electronic%20Personnel%20Licence%20(EPL)/electronic-personnel-license-epl-5056x3392.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "DGCA Electronic Personnel Licence (EPL) India | MH Cockpit",
    "twitterDescription": "DGCA Electronic Personnel Licence replaces physical pilot licences with a fully digital format via eGCA. Know what EPL means for your aviation career in India.",
    "twitterImage": "https://mhcockpit.com/Media/Training/DGCA%20Electronic%20Personnel%20Licence%20(EPL)/electronic-personnel-license-epl-5056x3392.webp"
  },
  "/training/bba-aviation-management": {
    "title": "Aviation Management Degree After 12th - BBA | MH Cockpit",
    "description": "Pursue a 3-year Aviation Management degree at UGC-approved colleges in India - airline operations, airport management, and aviation business.",
    "keywords": "BBA Aviation, Aviation Management degree, after 12th, UGC approved, airline operations, airport management, aviation business",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/bba-aviation-management",
    "ogTitle": "Aviation Management Degree After 12th - BBA | MH Cockpit",
    "ogDescription": "Pursue a 3-year Aviation Management degree at UGC-approved colleges in India - airline operations, airport management, and aviation business.",
    "ogUrl": "https://mhcockpit.com/training/bba-aviation-management",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/bba-aviation-management.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Management Degree After 12th - BBA | MH Cockpit",
    "twitterDescription": "Pursue a 3-year Aviation Management degree at UGC-approved colleges in India - airline operations, airport management, and aviation business.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/bba-aviation-management.webp"
  },
  "/training/bba-aviation-and-ground-handling": {
    "title": "Aviation Ground Handling Degree After 12th - BBA | MH Cockpit",
    "description": "BBA Aviation and Ground Handling is a 3-year UG degree at UGC-approved colleges in India covering airport operations, cargo, and passenger services.",
    "keywords": "BBA Aviation and Ground Handling, ground handling degree, airport operations, cargo services, passenger services, UGC approved",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/bba-aviation-and-ground-handling",
    "ogTitle": "Aviation Ground Handling Degree After 12th - BBA | MH Cockpit",
    "ogDescription": "BBA Aviation and Ground Handling is a 3-year UG degree at UGC-approved colleges in India covering airport operations, cargo, and passenger services.",
    "ogUrl": "https://mhcockpit.com/training/bba-aviation-and-ground-handling",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/bba-aviation-ground-handling.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Ground Handling Degree After 12th - BBA | MH Cockpit",
    "twitterDescription": "BBA Aviation and Ground Handling is a 3-year UG degree at UGC-approved colleges in India covering airport operations, cargo, and passenger services.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/bba-aviation-ground-handling.webp"
  },
  "/training/bsc-aviation": {
    "title": "BSc Aviation Degree After 12th - UGC Approved | MH Cockpit",
    "description": "BSc Aviation is a 3-year UG degree at UGC-approved colleges in India covering operations, airline management, safety, and logistics.",
    "keywords": "BSc Aviation, Aviation degree after 12th, UGC approved, aviation operations, airline management, safety, logistics, airline marketing",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/bsc-aviation",
    "ogTitle": "BSc Aviation Degree After 12th - UGC Approved | MH Cockpit",
    "ogDescription": "BSc Aviation is a 3-year UG degree at UGC-approved colleges in India covering operations, airline management, safety, and logistics.",
    "ogUrl": "https://mhcockpit.com/training/bsc-aviation",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/bsc-aviation.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "BSc Aviation Degree After 12th - UGC Approved | MH Cockpit",
    "twitterDescription": "BSc Aviation is a 3-year UG degree at UGC-approved colleges in India covering aviation operations, airline management, safety, logistics, and airline marketing.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/bsc-aviation.webp"
  },
  "/training/bsc-aeronautical-science": {
    "title": "BSc Aeronautical Science After 12th UGC-approved | MH Cockpit",
    "description": "BSc Aeronautical Science is a 3-year UG degree at UGC-approved colleges in India covering aerodynamics, aircraft systems, propulsion, and flight mechanics.",
    "keywords": "BSc Aeronautical Science, aeronautical science degree, after 12th, UGC approved, aerodynamics, aircraft systems, propulsion, flight mechanics",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/bsc-aeronautical-science",
    "ogTitle": "BSc Aeronautical Science After 12th UGC-approved | MH Cockpit",
    "ogDescription": "BSc Aeronautical Science is a 3-year UG degree at UGC-approved colleges in India covering aerodynamics, aircraft systems, propulsion, and flight mechanics.",
    "ogUrl": "https://mhcockpit.com/training/bsc-aeronautical-science",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/bsc-aeronautical-science.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "BSc Aeronautical Science After 12th UGC-approved | MH Cockpit",
    "twitterDescription": "BSc Aeronautical Science is a 3-year UG degree at UGC-approved colleges in India covering aerodynamics, aircraft systems, propulsion, and flight mechanics.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/bsc-aeronautical-science.webp"
  },
  "/training/btech-aeronautical-engineering": {
    "title": "B.Tech Aeronautical Engineering After 12th | AICTE Approved",
    "description": "B.Tech Aeronautical Engineering after 12th - AICTE approved 4-year degree. Learn aircraft design, aerodynamics, propulsion systems & aerospace careers.",
    "keywords": "B.Tech Aeronautical Engineering, Aeronautical Engineering after 12th, AICTE approved aeronautical engineering, aircraft design, aerodynamics, propulsion systems, aerospace structures, flight mechanics, avionics, aircraft maintenance, aerospace engineering degree, 4-year engineering programme, PCM eligibility, aeronautical engineering careers, aircraft design engineer, structural analysis engineer, aerodynamics engineer, manufacturing engineer, production engineer, R&D engineer, aerospace research, aircraft maintenance engineer, MRO specialist, defence aerospace, higher studies M.Tech, aerospace manufacturing, aircraft systems, simulation training, aerospace defence sector, engineering lab training, aircraft design projects, UAV designing, drone designing, aerospace growth India, technical engineering career, aerospace technology, engineering problem-solving, aeronautical subjects, core engineering fundamentals, practical exposure, industry interaction, career pathway",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/btech-aeronautical-engineering",
    "ogTitle": "B.Tech Aeronautical Engineering After 12th | AICTE Approved",
    "ogDescription": "B.Tech Aeronautical Engineering after 12th - AICTE approved 4-year degree. Learn aircraft design, aerodynamics, propulsion systems & aerospace careers.",
    "ogUrl": "https://mhcockpit.com/training/btech-aeronautical-engineering",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/btech-aero/b-tech-aeronautical-engineering-h.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "B.Tech Aeronautical Engineering After 12th | AICTE Approved",
    "twitterDescription": "B.Tech Aeronautical Engineering after 12th - AICTE approved 4-year degree. Learn aircraft design, aerodynamics, propulsion systems & aerospace careers.",
    "twitterImage": "https://mhcockpit.com/Media/Training/btech-aero/b-tech-aeronautical-engineering-h.webp"
  },
  "/training/mba-aviation-and-airport-management": {
    "title": "Aviation Management After Graduation - MBA | MH Cockpit",
    "description": "MBA Aviation and Airport Management is a 2-year PG degree at UGC-approved colleges in India covering airline management, airport operations, and policy.",
    "keywords": "MBA Aviation, Aviation Management PG, after graduation, UGC approved, airline management, airport operations, aviation policy",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/mba-aviation-and-airport-management",
    "ogTitle": "Aviation Management After Graduation - MBA | MH Cockpit",
    "ogDescription": "MBA Aviation and Airport Management is a 2-year PG degree at UGC-approved colleges in India covering airline management, airport operations, and policy.",
    "ogUrl": "https://mhcockpit.com/training/mba-aviation-and-airport-management",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/mba-aviation-and-airport-managemen.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Management After Graduation - MBA | MH Cockpit",
    "twitterDescription": "MBA Aviation and Airport Management is a 2-year PG degree at UGC-approved colleges in India covering airline management, airport operations, and policy.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/mba-aviation-and-airport-managemen.webp"
  },
  "/training/cabin-crew": {
    "title": "Cabin Crew Training Course After 12th in India | MH Cockpit",
    "description": "Premium cabin crew training certification - in-flight service, safety procedures, grooming standards, and customer service. Open to 12th pass candidates.",
    "keywords": "Cabin crew training, air hostess training, after 12th, in-flight service, safety procedures, grooming standards, customer service, certification",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/cabin-crew",
    "ogTitle": "Cabin Crew Training Course After 12th in India | MH Cockpit",
    "ogDescription": "Premium cabin crew training certification - in-flight service, safety procedures, grooming standards, and customer service. Open to 12th pass candidates.",
    "ogUrl": "https://mhcockpit.com/training/cabin-crew",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/certification-program-cabin-crew.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Cabin Crew Training Course After 12th in India | MH Cockpit",
    "twitterDescription": "Premium cabin crew training certification - in-flight service, safety procedures, grooming standards, and customer service. Open to 12th pass candidates.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/certification-program-cabin-crew.webp"
  },
  "/training/certification-in-airport-management": {
    "title": "Airport Management Certification Course in India | MH Cockpit",
    "description": "Premium airport management certification - airport operations, ground handling, passenger services, and aviation safety. Open to 12th pass candidates.",
    "keywords": "Airport management certification, airport operations, ground handling, passenger services, aviation safety, 12th pass",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/training/certification-in-airport-management",
    "ogTitle": "Airport Management Certification Course in India | MH Cockpit",
    "ogDescription": "Premium airport management certification - airport operations, ground handling, passenger services, and aviation safety. Open to 12th pass candidates.",
    "ogUrl": "https://mhcockpit.com/training/certification-in-airport-management",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/certification-in-airport-management.webp",
    "ogImageWidth": 5056,
    "ogImageHeight": 3392,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Airport Management Certification Course in India | MH Cockpit",
    "twitterDescription": "Premium airport management certification - airport operations, ground handling, passenger services, and aviation safety. Open to 12th pass candidates.",
    "twitterImage": "https://mhcockpit.com/Media/Training/compressed%20training%20page/certification-in-airport-management.webp"
  },
  "/technology": {
    "title": "Aviation Training Technology | LMS, VR/AR & Simulators",
    "description": "Explore MH Cockpit's aviation training systems: MIRA LMS, AME LMS, VR/AR, flight simulators, and ATC labs built for the next generation of aviators.",
    "keywords": "aviation training technology, aviation training systems, MIRA LMS, AME LMS, VR AR aviation training, flight simulator training, air traffic control training, aviation LMS, pilot training technology, immersive aviation training, aviation simulation, aviation education, aviation training India",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/technology",
    "ogTitle": "Aviation Training Technology | LMS, VR/AR & Simulators",
    "ogDescription": "From MIRA LMS and AME LMS to VR/AR, flight simulation, and ATC training, see how MH Cockpit connects technology with practical aviation learning.",
    "ogUrl": "https://mhcockpit.com/technology",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/technology/designed-for-the-next-generation-of-aviators.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Training Technology | LMS, VR/AR & Simulators",
    "twitterDescription": "Explore MH Cockpit's MIRA LMS, AME LMS, VR/AR, flight simulation, and ATC training systems built for the next generation of aviators.",
    "twitterImage": "https://mhcockpit.com/Media/technology/designed-for-the-next-generation-of-aviators.webp"
  },
  "/technology/mira-lms": {
    "title": "MIRA LMS | Aviation LMS for Institutions | MH Cockpit",
    "description": "MIRA LMS connects courses, assignments, assessments, and progress tracking in one platform for students, teachers, parents, and aviation institutions.",
    "keywords": "MIRA LMS, aviation LMS, aviation learning management system, LMS for aviation institutes, aviation education software, aviation training software, course management, assignment management, assessment management, student progress tracking, parent visibility LMS, aviation student progress tracking, aviation training technology, aviation institution LMS",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/technology/mira-lms",
    "ogTitle": "MIRA LMS | Connected Learning for Aviation Institutions",
    "ogDescription": "From course management to real-time progress tracking, MIRA LMS gives students, teachers, parents, and administrators a connected view of learning.",
    "ogUrl": "https://mhcockpit.com/technology/mira-lms",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/technology/mira-lms-dashboard.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "MIRA LMS | Aviation LMS for Students & Institutions",
    "twitterDescription": "Courses, assignments, assessments, and progress tracking unified in one platform. MIRA LMS is built for how aviation institutions teach and learn.",
    "twitterImage": "https://mhcockpit.com/Media/technology/mira-lms-dashboard.webp"
  },
  "/technology/ame-lms": {
    "title": "AME LMS | Aircraft Maintenance Training | MH Cockpit",
    "description": "AME LMS connects theory, practical training, assessments, and competency tracking in one platform for AME students, instructors, and training institutes.",
    "keywords": "AME LMS, aircraft maintenance LMS, AME training platform, AME learning management system, aircraft maintenance training, AME training software, competency tracking, AME module training, AME assessment system, AME training India, aviation training technology",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/technology/ame-lms",
    "ogTitle": "AME LMS | Aircraft Maintenance Training Platform | MH Cockpit",
    "ogDescription": "From module-based theory to instructor-verified practical tasks, AME LMS gives students, instructors, and parents a connected view of AME training progress.",
    "ogUrl": "https://mhcockpit.com/technology/ame-lms",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/technology/ame-lms-dashboard.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "AME LMS | Theory, Practice & Competency in One Platform",
    "twitterDescription": "Theory, practical training, competency tracking, and technical documentation unified in one platform. AME LMS is built for how maintenance skills are actually built.",
    "twitterImage": "https://mhcockpit.com/Media/technology/ame-lms-dashboard.webp"
  },
  "/technology/vr-ar-lms": {
    "title": "VR/AR LMS | Immersive Aviation Training | MH Cockpit",
    "description": "VR/AR LMS brings virtual experiments, interactive 3D models, and AR experiences together with assessments and progress tracking for aviation learners.",
    "keywords": "VR AR LMS, VR aviation training, AR aviation training, immersive aviation learning, virtual experiments aviation, interactive 3D models aviation, augmented reality aviation training, aviation simulation training, immersive aviation education, aviation learning platform, aviation training technology, VR AR aviation India",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/technology/vr-ar-lms",
    "ogTitle": "VR/AR LMS | Immersive Aviation Learning Platform",
    "ogDescription": "From virtual experiments to AR overlays and interactive 3D models, VR/AR LMS connects immersive experiences with assessments and real-time progress tracking.",
    "ogUrl": "https://mhcockpit.com/technology/vr-ar-lms",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/technology/vrar-lms-combines-immersive-technology.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "VR/AR LMS | See It. Do It. Understand It.",
    "twitterDescription": "Virtual experiments, interactive 3D models, and AR experiences unified with assessments and progress tracking. Built for how understanding is actually built.",
    "twitterImage": "https://mhcockpit.com/Media/technology/vrar-lms-combines-immersive-technology.webp"
  },
  "/technology/air-traffic-control-lab": {
    "title": "ATC Laboratory | Air Traffic Control Training | MH Cockpit",
    "description": "Train in a realistic ATC lab with controller workstations, two-way pilot interaction, scenario-based exercises, and instructor-controlled traffic simulations.",
    "keywords": "air traffic control laboratory, ATC training laboratory, ATC training lab, air traffic control training, ATC simulator, air traffic controller training, ATC simulation training, controller workstation, ATC scenario based training, ATC communication training, ATC practical training, air traffic control simulator, ATC training facility, ATC training India",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/technology/air-traffic-control-lab",
    "ogTitle": "ATC Laboratory | Realistic Controller Training Environment",
    "ogDescription": "From standard phraseology to live traffic scenarios, MH Cockpit's ATC Laboratory builds communication, coordination, and decision-making through practice.",
    "ogUrl": "https://mhcockpit.com/technology/air-traffic-control-lab",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/technology/air-traffic-control-lab-atc.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "ATC Laboratory | Listen. Communicate. Coordinate. Control.",
    "twitterDescription": "Real-time pilot interaction, scenario-based traffic, and instructor-controlled exercises. Built for how air traffic controllers actually train.",
    "twitterImage": "https://mhcockpit.com/Media/technology/air-traffic-control-lab-atc.webp"
  },
  "/technology/flight-simulator-lab": {
    "title": "Flight Simulator Lab | Pilot Training Simulator | MH Cockpit",
    "description": "Step into a realistic cockpit with live controls, instrument panels, and instructor-led flight scenarios covering every phase from taxi to landing.",
    "keywords": "flight simulator lab, flight simulator training, pilot training simulator, flight simulation training, aviation simulator, cockpit simulator, pilot training facility, flight procedures training, cockpit systems training, simulator based training, aviation training technology, flight simulator India",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/technology/flight-simulator-lab",
    "ogTitle": "Flight Simulator Lab | Realistic Cockpit Training Facility",
    "ogDescription": "From cockpit familiarization to emergency scenarios, MH Cockpit's Flight Simulator Lab connects aviation theory to real flight procedures in a hands-on environment.",
    "ogUrl": "https://mhcockpit.com/technology/flight-simulator-lab",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/technology/flight-simulator-laboratory.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Flight Simulator Lab | Step Into the Cockpit.",
    "twitterDescription": "Realistic cockpit controls, full-phase flight simulation, and instructor-led scenarios. Built for how pilots actually learn through practice, not observation.",
    "twitterImage": "https://mhcockpit.com/Media/technology/flight-simulator-laboratory.webp"
  },
  "/innovation": {
    "title": "Innovation in Aviation Training | MH Cockpit",
    "description": "MH Cockpit leverages cutting-edge technology and innovation in aviation training - simulators, VR, and advanced teaching methodologies.",
    "keywords": "aviation innovation, flight simulators, VR training, aviation technology, MH Cockpit innovation",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/innovation",
    "ogTitle": "Innovation in Aviation Training | MH Cockpit",
    "ogDescription": "MH Cockpit leverages cutting-edge technology and innovation in aviation training - simulators, VR, and advanced teaching methodologies.",
    "ogUrl": "https://mhcockpit.com/innovation",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Innovation/pilot-training-innovation-mh-cockpit.webp",
    "ogImageWidth": 731,
    "ogImageHeight": 411,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Innovation in Aviation Training | MH Cockpit",
    "twitterDescription": "MH Cockpit leverages cutting-edge technology and innovation in aviation training - simulators, VR, and advanced teaching methodologies.",
    "twitterImage": "https://mhcockpit.com/Media/Innovation/pilot-training-innovation-mh-cockpit.webp"
  },
  "/innovation/flight-simulator": {
    "title": "Flight Simulator Training | MH Cockpit Innovation",
    "description": "Experience advanced flight simulator training at MH Cockpit. Realistic flight scenarios for CPL, Type Rating, and pilot skill development.",
    "keywords": "flight simulator, pilot training, CPL simulator, type rating simulator, aviation training, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/innovation/flight-simulator",
    "ogTitle": "Flight Simulator Training | MH Cockpit Innovation",
    "ogDescription": "Experience advanced flight simulator training at MH Cockpit. Realistic flight scenarios for CPL, Type Rating, and pilot skill development.",
    "ogUrl": "https://mhcockpit.com/innovation/flight-simulator",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Innovation/flight-simulator-training-mh-cockpit.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Flight Simulator Training | MH Cockpit Innovation",
    "twitterDescription": "Experience advanced flight simulator training at MH Cockpit. Realistic flight scenarios for CPL, Type Rating, and pilot skill development.",
    "twitterImage": "https://mhcockpit.com/Media/Innovation/flight-simulator-training-mh-cockpit.webp"
  },
  "/innovation/flight-simulator/cessna": {
    "title": "Cessna Flight Simulator Training | MH Cockpit",
    "description": "Cessna flight simulator training at MH Cockpit - realistic Cessna 172 flying experience for PPL and CPL students. Book your session now.",
    "keywords": "Cessna simulator, Cessna 172, PPL training, CPL training, flight simulator, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/innovation/flight-simulator/cessna",
    "ogTitle": "Cessna Flight Simulator Training | MH Cockpit",
    "ogDescription": "Cessna flight simulator training at MH Cockpit - realistic Cessna 172 flying experience for PPL and CPL students. Book your session now.",
    "ogUrl": "https://mhcockpit.com/innovation/flight-simulator/cessna",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Flight%20Simulator/cessna.webp",
    "ogImageWidth": 3062,
    "ogImageHeight": 1391,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Cessna Flight Simulator Training | MH Cockpit",
    "twitterDescription": "Cessna flight simulator training at MH Cockpit - realistic Cessna 172 flying experience for PPL and CPL students.",
    "twitterImage": "https://mhcockpit.com/Media/Flight%20Simulator/cessna.webp"
  },
  "/innovation/flight-simulator/airbus": {
    "title": "Airbus Flight Simulator Training | MH Cockpit",
    "description": "Airbus A320 flight simulator training at MH Cockpit - type rating preparation and advanced pilot training for commercial airline careers.",
    "keywords": "Airbus simulator, A320 simulator, type rating, commercial pilot training, MH Cockpit, airline training",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/innovation/flight-simulator/airbus",
    "ogTitle": "Airbus Flight Simulator Training | MH Cockpit",
    "ogDescription": "Airbus A320 flight simulator training at MH Cockpit - type rating preparation and advanced pilot training for commercial airline careers.",
    "ogUrl": "https://mhcockpit.com/innovation/flight-simulator/airbus",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Flight%20Simulator/airbus.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 872,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Airbus Flight Simulator Training | MH Cockpit",
    "twitterDescription": "Airbus A320 flight simulator training at MH Cockpit - type rating preparation and advanced pilot training for commercial airline careers.",
    "twitterImage": "https://mhcockpit.com/Media/Flight%20Simulator/airbus.webp"
  },
  "/innovation/flight-simulator/boeing": {
    "title": "Boeing Flight Simulator Training | MH Cockpit",
    "description": "Boeing B737 flight simulator training at MH Cockpit - type rating preparation and advanced pilot training for commercial airline careers.",
    "keywords": "Boeing simulator, B737 simulator, type rating, commercial pilot training, MH Cockpit, airline training",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/innovation/flight-simulator/boeing",
    "ogTitle": "Boeing Flight Simulator Training | MH Cockpit",
    "ogDescription": "Boeing B737 flight simulator training at MH Cockpit - type rating preparation and advanced pilot training for commercial airline careers.",
    "ogUrl": "https://mhcockpit.com/innovation/flight-simulator/boeing",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Flight%20Simulator/boeing-737.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 872,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Boeing Flight Simulator Training | MH Cockpit",
    "twitterDescription": "Boeing B737 flight simulator training at MH Cockpit - type rating preparation and advanced pilot training for commercial airline careers.",
    "twitterImage": "https://mhcockpit.com/Media/Flight%20Simulator/boeing-737.webp"
  },
  "/innovation/fixed-wing": {
    "title": "Fixed Wing Aircraft Training | MH Cockpit Innovation",
    "description": "Fixed wing aircraft training at MH Cockpit - comprehensive flight training for PPL, CPL, and commercial pilot careers.",
    "keywords": "fixed wing training, aircraft training, PPL, CPL, commercial pilot, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/innovation/fixed-wing",
    "ogTitle": "Fixed Wing Aircraft Training | MH Cockpit Innovation",
    "ogDescription": "Fixed wing aircraft training at MH Cockpit - comprehensive flight training for PPL, CPL, and commercial pilot careers.",
    "ogUrl": "https://mhcockpit.com/innovation/fixed-wing",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Innovation/fixed-wing-aircraft-training-mh-cockpit.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Fixed Wing Aircraft Training | MH Cockpit Innovation",
    "twitterDescription": "Fixed wing aircraft training at MH Cockpit - comprehensive flight training for PPL, CPL, and commercial pilot careers.",
    "twitterImage": "https://mhcockpit.com/Media/Innovation/fixed-wing-aircraft-training-mh-cockpit.webp"
  },
  "/colleges": {
    "title": "Top Aviation Colleges in India - UGC Approved | MH Cockpit",
    "description": "MH Cockpit partners with top UGC-approved aviation universities across India, offering BSc, BBA, and MBA Aviation in Tamil Nadu, Bangalore, and Mathura.",
    "keywords": "Top aviation colleges, UGC approved, aviation universities, BSc Aviation, BBA Aviation, MBA Aviation, Tamil Nadu, Bangalore, Mathura",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges",
    "ogTitle": "Top Aviation Colleges in India - UGC Approved | MH Cockpit",
    "ogDescription": "MH Cockpit partners with top UGC-approved aviation universities across India, offering BSc, BBA, and MBA Aviation in Tamil Nadu, Bangalore, and Mathura.",
    "ogUrl": "https://mhcockpit.com/colleges",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/top-aviation-colleges-india-campus-training.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Top Aviation Colleges in India - UGC Approved | MH Cockpit",
    "twitterDescription": "MH Cockpit partners with top UGC-approved aviation universities across India, offering BSc, BBA, and MBA Aviation.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/top-aviation-colleges-india-campus-training.webp"
  },
  "/colleges/vels-university": {
    "title": "Aviation Courses at Vels University Chennai | MH Cockpit",
    "description": "Vels University in Chennai offers BSc Aeronautical Science, BSc Aviation, BBA Aviation, MBA Aviation & Airport Management, and cabin crew certifications.",
    "keywords": "Vels University, Chennai, BSc Aviation, BSc Aeronautical Science, BBA Aviation, MBA Aviation, UGC recognised, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/vels-university",
    "ogTitle": "Aviation Courses at Vels University Chennai | MH Cockpit",
    "ogDescription": "Vels University in Chennai offers BSc Aeronautical Science, BSc Aviation, BBA Aviation, MBA Aviation & Airport Management, and cabin crew certifications.",
    "ogUrl": "https://mhcockpit.com/colleges/vels-university",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/vels-university-aviation-programs-mh-cockpit.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Courses at Vels University Chennai | MH Cockpit",
    "twitterDescription": "Vels University in Chennai offers BSc Aeronautical Science, BSc Aviation, BBA Aviation, MBA Aviation & Airport Management, and cabin crew certifications.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/vels-university-aviation-programs-mh-cockpit.webp"
  },
  "/colleges/alliance-university": {
    "title": "Aviation Courses in Bangalore: BSc, Integrated CPL, BBA & Cabin Crew | MH Cockpit",
    "description": "Alliance University in Bangalore offers BSc in Aviation / Aeronautical Science, Integrated CPL Programme, BBA Aviation Management, and Certification Course in Cabin Crew.",
    "keywords": "Alliance University, Bangalore, BBA Aviation Management, BSc Aviation, BSc Aeronautical Science, Integrated CPL, Cabin Crew, after 12th, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/alliance-university",
    "ogTitle": "Aviation Courses in Bangalore: BSc, Integrated CPL, BBA & Cabin Crew | MH Cockpit",
    "ogDescription": "Alliance University in Bangalore offers BSc in Aviation / Aeronautical Science, Integrated CPL Programme, BBA Aviation Management, and Certification Course in Cabin Crew.",
    "ogUrl": "https://mhcockpit.com/colleges/alliance-university",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/alliance-university-aviation-courses-mh-cockpit.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Courses in Bangalore: BSc, Integrated CPL, BBA & Cabin Crew | MH Cockpit",
    "twitterDescription": "Alliance University in Bangalore offers BSc in Aviation / Aeronautical Science, Integrated CPL Programme, BBA Aviation Management, and Certification Course in Cabin Crew.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/alliance-university-aviation-courses-mh-cockpit.webp"
  },
  "/colleges/bharath-university": {
    "title": "Aviation Courses at Bharath University Chennai | MH Cockpit",
    "description": "Bharath University offers BSc Aviation and BSc Aeronautical Science in Chennai. Focus on airport operations, airline management, and ground handling.",
    "keywords": "Bharath University, Chennai, BSc Aviation, BBA Aviation Management, UGC recognised, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/bharath-university",
    "ogTitle": "Aviation Courses at Bharath University Chennai | MH Cockpit",
    "ogDescription": "Bharath University offers BSc Aviation and BSc Aeronautical Science in Chennai. Focus on airport operations, airline management, and ground handling.",
    "ogUrl": "https://mhcockpit.com/colleges/bharath-university",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/bharath-university-banner.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Courses at Bharath University Chennai | MH Cockpit",
    "twitterDescription": "Bharath University offers BSc Aviation and BSc Aeronautical Science in Chennai. Focus on airport operations, airline management, and ground handling.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/bharath-university-banner.webp"
  },
  "/colleges/crescent-university": {
    "title": "Aviation Courses at Crescent University Chennai | MH Cockpit",
    "description": "Crescent University in Chennai offers BSc Aviation, BBA Aviation Management, and certification programs - UGC recognised aviation courses with MH Cockpit.",
    "keywords": "Crescent University, Chennai, BSc Aviation, BBA Aviation Management, UGC recognised, MH Cockpit, aviation courses",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/crescent-university",
    "ogTitle": "Aviation Courses at Crescent University Chennai | MH Cockpit",
    "ogDescription": "Crescent University in Chennai offers BSc Aviation, BBA Aviation Management, and certification programs - UGC recognised aviation courses with MH Cockpit.",
    "ogUrl": "https://mhcockpit.com/colleges/crescent-university",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/crescent-university-aviation-courses-mh-cockpit.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Courses at Crescent University Chennai | MH Cockpit",
    "twitterDescription": "Crescent University in Chennai offers BSc Aviation, BBA Aviation Management, and certification programs - UGC recognised aviation courses with MH Cockpit.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/crescent-university-aviation-courses-mh-cockpit.webp"
  },
  "/colleges/bishop-heber-college": {
    "title": "Aviation Courses at Bishop Heber College Trichy | MH Cockpit",
    "description": "Bishop Heber College in Trichy offers BSc Aviation and BBA Aviation programs. Industry-connected curriculum with practical training.",
    "keywords": "Bishop Heber College, Trichy, BSc Aviation, UGC recognised, MH Cockpit, aviation courses",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/bishop-heber-college",
    "ogTitle": "Aviation Courses at Bishop Heber College Trichy | MH Cockpit",
    "ogDescription": "Bishop Heber College in Trichy offers BSc Aviation and BBA Aviation programs. Industry-connected curriculum with practical training.",
    "ogUrl": "https://mhcockpit.com/colleges/bishop-heber-college",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/bishop-heber-college-aviation-courses-mh-cockpit.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Courses at Bishop Heber College Trichy | MH Cockpit",
    "twitterDescription": "Bishop Heber College in Trichy offers BSc Aviation and BBA Aviation programs. Industry-connected curriculum with practical training.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/bishop-heber-college-aviation-courses-mh-cockpit.webp"
  },
  "/colleges/jamal-mohamed-college": {
    "title": "Aviation Courses at Jamal Mohamed College Trichy | MH Cockpit",
    "description": "Jamal Mohamed College in Trichy offers BSc Aviation, BBA Aviation Management, and certification programs - UGC recognised aviation courses with MH Cockpit.",
    "keywords": "Jamal Mohamed College, Trichy, BSc Aviation, BBA Aviation Management, UGC recognised, MH Cockpit, aviation courses",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/jamal-mohamed-college",
    "ogTitle": "Aviation Courses at Jamal Mohamed College Trichy | MH Cockpit",
    "ogDescription": "Jamal Mohamed College in Trichy offers BSc Aviation, BBA Aviation Management, and certification programs - UGC recognised aviation courses with MH Cockpit.",
    "ogUrl": "https://mhcockpit.com/colleges/jamal-mohamed-college",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/jamal-mohamed-college-aviation-programs-mh-cockpit.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Courses at Jamal Mohamed College Trichy | MH Cockpit",
    "twitterDescription": "Jamal Mohamed College in Trichy offers BSc Aviation, BBA Aviation Management, and certification programs - UGC recognised aviation courses with MH Cockpit.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/jamal-mohamed-college-aviation-programs-mh-cockpit.webp"
  },
  "/colleges/kalasalingam-university": {
    "title": "Kalasalingam University Aviation Programs | MH Cockpit",
    "description": "Kalasalingam University offers BBA Aviation, BSc Aviation, BSc Aeronautical Science & MBA programs in Virudhunagar. Industry-focused curriculum.",
    "keywords": "Kalasalingam University, BSc Aviation, BBA Aviation Management, UGC recognised, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/kalasalingam-university",
    "ogTitle": "Kalasalingam University Aviation Programs | MH Cockpit",
    "ogDescription": "Kalasalingam University offers BBA Aviation, BSc Aviation, BSc Aeronautical Science & MBA programs in Virudhunagar. Industry-focused curriculum.",
    "ogUrl": "https://mhcockpit.com/colleges/kalasalingam-university",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/kalasalingam-university-school-of-aviation.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Kalasalingam University Aviation Programs | MH Cockpit",
    "twitterDescription": "Kalasalingam University offers BBA Aviation, BSc Aviation, BSc Aeronautical Science & MBA programs in Virudhunagar. Industry-focused curriculum.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/kalasalingam-university-school-of-aviation.webp"
  },
  "/colleges/sanskriti-university": {
    "title": "Sanskriti University Aviation Programs | MH Cockpit",
    "description": "Sanskriti University offers BSc Aviation, BTech Aeronautical, and MBA Aviation Management in Mathura. Industry-connected curriculum with hands-on training.",
    "keywords": "Sanskriti University, Mathura, BSc Aviation, BBA Aviation Management, MBA Aviation, UGC recognised, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/sanskriti-university",
    "ogTitle": "Sanskriti University Aviation Programs | MH Cockpit",
    "ogDescription": "Sanskriti University offers BSc Aviation, BTech Aeronautical, and MBA Aviation Management in Mathura. Industry-connected curriculum with hands-on training.",
    "ogUrl": "https://mhcockpit.com/colleges/sanskriti-university",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/sanskriti-university-school-of-aviation.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Sanskriti University Aviation Programs | MH Cockpit",
    "twitterDescription": "Sanskriti University offers BSc Aviation, BTech Aeronautical, and MBA Aviation Management in Mathura. Industry-connected curriculum with hands-on training.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/sanskriti-university-school-of-aviation.webp"
  },
  "/colleges/sasurie-college": {
    "title": "Aviation Courses at Sasurie College | MH Cockpit",
    "description": "Sasurie College in Tirupur offers BBA and MBA Aviation Management. Focus on airport operations, airline services, and ground handling. UGC-recognised.",
    "keywords": "Sasurie College, BSc Aviation, UGC recognised, MH Cockpit, aviation courses",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/sasurie-college",
    "ogTitle": "Aviation Courses at Sasurie College | MH Cockpit",
    "ogDescription": "Sasurie College in Tirupur offers BBA and MBA Aviation Management. Focus on airport operations, airline services, and ground handling. UGC-recognised.",
    "ogUrl": "https://mhcockpit.com/colleges/sasurie-college",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/sasurie-college-the-school-of-aviation.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Courses at Sasurie College | MH Cockpit",
    "twitterDescription": "Sasurie College in Tirupur offers BBA and MBA Aviation Management. Focus on airport operations, airline services, and ground handling. UGC-recognised.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/sasurie-college-the-school-of-aviation.webp"
  },
  "/colleges/ganpat-university": {
    "title": "Aviation Courses at Ganpat University, Gujarat & Goa",
    "description": "Ganpat University offers BBA Aviation Management at Gujarat & Goa campuses. Airport operations, airline services, and ground handling. Any stream eligible.",
    "keywords": "BBA aviation management Ganpat University, aviation courses Ganpat University, BBA aviation management Gujarat, BBA aviation management Goa, Ganpat University aviation, aviation management degree Gujarat, airport operations degree India, airline management degree India, ground handling management program, aviation management college Gujarat, BBA aviation any stream, aviation degree Goa, airport management degree India, aviation courses Gujarat, aviation management program India, aviation management admission 2026, BBA aviation degree 2026, Ganpat University BBA program, NAAC A university aviation Gujarat, aviation courses Mehsana, airline services degree India, aviation management college Goa",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/ganpat-university",
    "ogTitle": "Aviation Courses at Ganpat University, Gujarat & Goa",
    "ogDescription": "Ganpat University offers BBA Aviation Management at Gujarat & Goa campuses. Airport operations, airline services, and ground handling. Any stream eligible.",
    "ogUrl": "https://mhcockpit.com/colleges/ganpat-university",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/Ganpat-University/Converted/ganpat-university.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Courses at Ganpat University, Gujarat & Goa",
    "twitterDescription": "Ganpat University offers BBA Aviation Management at Gujarat & Goa campuses. Airport operations, airline services, and ground handling. Any stream eligible.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/Ganpat-University/Converted/ganpat-university.webp"
  },
  "/careers": {
    "title": "Careers at MH Cockpit | Aviation Training Jobs",
    "description": "Explore career opportunities at MH Cockpit - pilot instructors, AME instructors, cabin crew trainers, and aviation training professionals.",
    "keywords": "aviation careers, MH Cockpit jobs, pilot instructor, AME instructor, cabin crew trainer, aviation training jobs",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers",
    "ogTitle": "Careers at MH Cockpit | Aviation Training Jobs",
    "ogDescription": "Explore career opportunities at MH Cockpit - pilot instructors, AME instructors, cabin crew trainers, and aviation training professionals.",
    "ogUrl": "https://mhcockpit.com/careers",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Careers at MH Cockpit | Aviation Training Jobs",
    "twitterDescription": "Explore career opportunities at MH Cockpit - pilot instructors, AME instructors, cabin crew trainers, and aviation training professionals.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/careers/pilot-ground-instructor": {
    "title": "Pilot Ground Instructor Careers | MH Cockpit",
    "description": "Join MH Cockpit as a Pilot Ground Instructor - teach DGCA ground subjects, mentor aspiring pilots, and shape the future of aviation.",
    "keywords": "pilot ground instructor, DGCA instructor, aviation teacher, PPL instructor, CPL instructor, MH Cockpit careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/pilot-ground-instructor",
    "ogTitle": "Pilot Ground Instructor Careers | MH Cockpit",
    "ogDescription": "Join MH Cockpit as a Pilot Ground Instructor - teach DGCA ground subjects, mentor aspiring pilots, and shape the future of aviation.",
    "ogUrl": "https://mhcockpit.com/careers/pilot-ground-instructor",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Careers/Converted/pilot-ground-instructor.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Pilot Ground Instructor Careers | MH Cockpit",
    "twitterDescription": "Join MH Cockpit as a Pilot Ground Instructor - teach DGCA ground subjects, mentor aspiring pilots, and shape the future of aviation.",
    "twitterImage": "https://mhcockpit.com/Media/Careers/Converted/pilot-ground-instructor.webp"
  },
  "/careers/ame-instructor": {
    "title": "AME Instructor Careers | MH Cockpit",
    "description": "Join MH Cockpit as an Aircraft Maintenance Engineering (AME) Instructor - teach aircraft systems, maintenance, and DGCA AME syllabus.",
    "keywords": "AME instructor, aircraft maintenance instructor, DGCA AME, aviation teacher, MH Cockpit careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/ame-instructor",
    "ogTitle": "AME Instructor Careers | MH Cockpit",
    "ogDescription": "Join MH Cockpit as an Aircraft Maintenance Engineering (AME) Instructor - teach aircraft systems, maintenance, and DGCA AME syllabus.",
    "ogUrl": "https://mhcockpit.com/careers/ame-instructor",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "\thttps://mhcockpit.com/Media/Careers/Converted/ame-instructors.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "AME Instructor Careers | MH Cockpit",
    "twitterDescription": "Join MH Cockpit as an Aircraft Maintenance Engineering (AME) Instructor - teach aircraft systems, maintenance, and DGCA AME syllabus.",
    "twitterImage": "\thttps://mhcockpit.com/Media/Careers/Converted/ame-instructors.webp"
  },
  "/careers/cabin-crew-instructor": {
    "title": "Cabin Crew Instructor Careers | MH Cockpit",
    "description": "Join MH Cockpit as a Cabin Crew Instructor - train aspiring air hostesses and flight attendants in safety, service, and grooming standards.",
    "keywords": "cabin crew instructor, air hostess trainer, flight attendant instructor, MH Cockpit careers, aviation training",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/cabin-crew-instructor",
    "ogTitle": "Cabin Crew Instructor Careers | MH Cockpit",
    "ogDescription": "Join MH Cockpit as a Cabin Crew Instructor - train aspiring air hostesses and flight attendants in safety, service, and grooming standards.",
    "ogUrl": "https://mhcockpit.com/careers/cabin-crew-instructor",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Careers/Converted/cabin-crew-instructor.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Cabin Crew Instructor Careers | MH Cockpit",
    "twitterDescription": "Join MH Cockpit as a Cabin Crew Instructor - train aspiring air hostesses and flight attendants in safety, service, and grooming standards.",
    "twitterImage": "https://mhcockpit.com/Media/Careers/Converted/cabin-crew-instructor.webp"
  },
  "/careers/ground-operations-trainer": {
    "title": "Ground Operations Trainer Careers | MH Cockpit",
    "description": "Join MH Cockpit as a Ground Operations Trainer - teach airport ground handling, passenger services, cargo operations, and aviation safety.",
    "keywords": "ground operations trainer, airport trainer, ground handling instructor, MH Cockpit careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/ground-operations-trainer",
    "ogTitle": "Ground Operations Trainer Careers | MH Cockpit",
    "ogDescription": "Join MH Cockpit as a Ground Operations Trainer - teach airport ground handling, passenger services, cargo operations, and aviation safety.",
    "ogUrl": "https://mhcockpit.com/careers/ground-operations-trainer",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Careers/Converted/ground-operations-trainer.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Ground Operations Trainer Careers | MH Cockpit",
    "twitterDescription": "Join MH Cockpit as a Ground Operations Trainer - teach airport ground handling, passenger services, cargo operations, and aviation safety.",
    "twitterImage": "https://mhcockpit.com/Media/Careers/Converted/ground-operations-trainer.webp"
  },
  "/careers/flight-dispatch": {
    "title": "Flight Dispatch Careers | MH Cockpit",
    "description": "Join MH Cockpit as a Flight Dispatch Trainer - teach flight planning, operational control, and aviation regulations to aspiring dispatchers.",
    "keywords": "flight dispatch, aviation dispatcher, flight planning trainer, MH Cockpit careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/flight-dispatch",
    "ogTitle": "Flight Dispatch Careers | MH Cockpit",
    "ogDescription": "Join MH Cockpit as a Flight Dispatch Trainer - teach flight planning, operational control, and aviation regulations to aspiring dispatchers.",
    "ogUrl": "https://mhcockpit.com/careers/flight-dispatch",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Careers/Converted/flight-dispatch.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Flight Dispatch Careers | MH Cockpit",
    "twitterDescription": "Join MH Cockpit as a Flight Dispatch Trainer - teach flight planning, operational control, and aviation regulations to aspiring dispatchers.",
    "twitterImage": "https://mhcockpit.com/Media/Careers/Converted/flight-dispatch.webp"
  },
  "/careers/it": {
    "title": "IT Careers at MH Cockpit | Aviation Technology",
    "description": "Join MH Cockpit's IT team - develop aviation software, manage simulators, and build technology solutions for the aviation training industry.",
    "keywords": "IT careers, aviation technology, software development, simulator technology, MH Cockpit careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/it",
    "ogTitle": "IT Careers at MH Cockpit | Aviation Technology",
    "ogDescription": "Join MH Cockpit's IT team - develop aviation software, manage simulators, and build technology solutions for the aviation training industry.",
    "ogUrl": "https://mhcockpit.com/careers/it",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "\thttps://mhcockpit.com/Media/Careers/Converted/information-technology.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "IT Careers at MH Cockpit | Aviation Technology",
    "twitterDescription": "Join MH Cockpit's IT team - develop aviation software, manage simulators, and build technology solutions for the aviation training industry.",
    "twitterImage": "\thttps://mhcockpit.com/Media/Careers/Converted/information-technology.webp"
  },
  "/careers/finance": {
    "title": "Finance Careers in Aviation | MH Cockpit",
    "description": "Explore finance and accounting career opportunities at MH Cockpit. Join our finance team managing aviation education operations and financial planning.",
    "keywords": "media careers, content creation, aviation media, social media, video production, MH Cockpit careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/finance",
    "ogTitle": "Finance Careers in Aviation | MH Cockpit",
    "ogDescription": "Explore finance and accounting career opportunities at MH Cockpit. Join our finance team managing aviation education operations and financial planning.",
    "ogUrl": "https://mhcockpit.com/careers/finance",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Careers/Cover/finance.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Finance Careers in Aviation | MH Cockpit",
    "twitterDescription": "Explore finance and accounting career opportunities at MH Cockpit. Join our finance team managing aviation education operations and financial planning.",
    "twitterImage": "https://mhcockpit.com/Media/Careers/Cover/finance.webp"
  },
  "/careers/drone-pilots": {
    "title": "Drone Pilot Careers | MH Cockpit",
    "description": "Join MH Cockpit as a Drone Pilot Instructor - train aspiring drone pilots in UAV operations, regulations, and commercial drone applications.",
    "keywords": "drone pilot, UAV instructor, drone training, commercial drone, MH Cockpit careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/drone-pilots",
    "ogTitle": "Drone Pilot Careers | MH Cockpit",
    "ogDescription": "Join MH Cockpit as a Drone Pilot Instructor - train aspiring drone pilots in UAV operations, regulations, and commercial drone applications.",
    "ogUrl": "https://mhcockpit.com/careers/drone-pilots",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Careers/Converted/drone-pilot-and-engineer.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Drone Pilot Careers | MH Cockpit",
    "twitterDescription": "Join MH Cockpit as a Drone Pilot Instructor - train aspiring drone pilots in UAV operations, regulations, and commercial drone applications.",
    "twitterImage": "https://mhcockpit.com/Media/Careers/Converted/drone-pilot-and-engineer.webp"
  },
  "/careers/bdm": {
    "title": "Business Development Careers at MH Cockpit | Aviation",
    "description": "Join MH Cockpit's Business Development team - drive aviation training partnerships, college collaborations, and growth initiatives.",
    "keywords": "BDM, business development, aviation partnerships, college collaborations, MH Cockpit careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/bdm",
    "ogTitle": "Business Development Careers at MH Cockpit | Aviation",
    "ogDescription": "Join MH Cockpit's Business Development team - drive aviation training partnerships, college collaborations, and growth initiatives.",
    "ogUrl": "https://mhcockpit.com/careers/bdm",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "\thttps://mhcockpit.com/Media/Careers/Converted/business-development-manager.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Business Development Careers at MH Cockpit | Aviation",
    "twitterDescription": "Join MH Cockpit's Business Development team - drive aviation training partnerships, college collaborations, and growth initiatives.",
    "twitterImage": "\thttps://mhcockpit.com/Media/Careers/Converted/business-development-manager.webp"
  },
  "/careers/media": {
    "title": "Media Careers at MH Cockpit | Aviation Content Creation",
    "description": "Join MH Cockpit's Media team - create aviation content, manage social media, produce videos, and showcase aviation training excellence.",
    "keywords": "media careers, content creation, aviation media, social media, video production, MH Cockpit careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/careers/media",
    "ogTitle": "Media Careers at MH Cockpit | Aviation Content Creation",
    "ogDescription": "Join MH Cockpit's Media team - create aviation content, manage social media, produce videos, and showcase aviation training excellence.",
    "ogUrl": "https://mhcockpit.com/careers/media",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Careers/Converted/media.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Media Careers at MH Cockpit | Aviation Content Creation",
    "twitterDescription": "Join MH Cockpit's Media team - create aviation content, manage social media, produce videos, and showcase aviation training excellence.",
    "twitterImage": "https://mhcockpit.com/Media/Careers/Converted/media.webp"
  },
  "/blogs": {
    "title": "Aviation Blogs | MH Cockpit - Latest Industry Insights",
    "description": "Read the latest aviation blogs from MH Cockpit covering pilot training, DGCA updates, career guidance, and industry trends.",
    "keywords": "aviation blogs, pilot training tips, DGCA updates, aviation career, MH Cockpit blog",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/blogs",
    "ogTitle": "Aviation Blogs | MH Cockpit - Latest Industry Insights",
    "ogDescription": "Read the latest aviation blogs from MH Cockpit covering pilot training, DGCA updates, career guidance, and industry trends.",
    "ogUrl": "https://mhcockpit.com/blogs",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Blogs | MH Cockpit - Latest Industry Insights",
    "twitterDescription": "Read the latest aviation blogs from MH Cockpit covering pilot training, DGCA updates, career guidance, and industry trends.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/blogs/education-loan-emi-calculator": {
    "title": "Education Loan EMI Calculator: Calculate Monthly EMI Instantly",
    "description": "Calculate your education loan EMI instantly with our free online calculator. Estimate monthly repayments, total interest, and plan your education financing.",
    "keywords": "education loan EMI calculator, monthly EMI, education loan repayment, loan calculator, student loan EMI, education finance",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/blogs/education-loan-emi-calculator",
    "ogTitle": "Education Loan EMI Calculator: Calculate Monthly EMI Instantly",
    "ogDescription": "Calculate your education loan EMI instantly with our free online calculator. Estimate monthly repayments, total interest, and plan your education financing.",
    "ogUrl": "https://mhcockpit.com/blogs/education-loan-emi-calculator",
    "ogType": "article",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/blogs/emi-calculator/loan-calculator.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Education Loan EMI Calculator: Calculate Monthly EMI Instantly",
    "twitterDescription": "Calculate your education loan EMI instantly with our free online calculator. Estimate monthly repayments, total interest, and plan your education financing.",
    "twitterImage": "https://mhcockpit.com/Media/blogs/emi-calculator/loan-calculator.webp"
  },
  "/students/gallery": {
    "title": "Gallery | MH Cockpit Aviation Training Moments",
    "description": "Browse our gallery showcasing aviation training moments, aircraft, simulators, and campus facilities at MH Cockpit.",
    "keywords": "aviation gallery, MH Cockpit photos, training facilities, pilot training images, aviation campus",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/students/gallery",
    "ogTitle": "Gallery | MH Cockpit Aviation Training Moments",
    "ogDescription": "Browse our gallery showcasing aviation training moments, aircraft, simulators, and campus facilities at MH Cockpit.",
    "ogUrl": "https://mhcockpit.com/students/gallery",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Gallery/Cover/GALLERY.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Gallery | MH Cockpit Aviation Training Moments",
    "twitterDescription": "Browse our gallery showcasing aviation training moments, aircraft, simulators, and campus facilities at MH Cockpit.",
    "twitterImage": "https://mhcockpit.com/Media/Gallery/Cover/GALLERY.webp"
  },
  "/about-us": {
    "title": "About MH Cockpit | Leading Aviation Training Institute in India",
    "description": "MH Cockpit is a leading aviation training institute in India offering DGCA-aligned pilot training, UGC-approved degree programs, and certification courses.",
    "keywords": "about MH Cockpit, aviation training institute, pilot training, DGCA approved, UGC approved, aviation courses India",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/about-us",
    "ogTitle": "About MH Cockpit | Leading Aviation Training Institute in India",
    "ogDescription": "MH Cockpit is a leading aviation training institute in India offering DGCA-aligned pilot training, UGC-approved degree programs, and certification courses.",
    "ogUrl": "https://mhcockpit.com/about-us",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "About MH Cockpit | Leading Aviation Training Institute in India",
    "twitterDescription": "MH Cockpit is a leading aviation training institute in India offering DGCA-aligned pilot training, UGC-approved degree programs, and certification courses.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/about-us/our-governance": {
    "title": "Our Governance | MH Cockpit - Aviation Training Institute",
    "description": "MH Cockpit ensures transparent and quality-driven aviation training governance. Learn about our leadership approach and academic standards.",
    "keywords": "aviation governance, MH Cockpit leadership, training quality, aviation standards, educational governance",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/about-us/our-governance",
    "ogTitle": "Our Governance | MH Cockpit - Aviation Training Institute",
    "ogDescription": "MH Cockpit ensures transparent and quality-driven aviation training governance. Learn about our leadership approach and academic standards.",
    "ogUrl": "https://mhcockpit.com/about-us/our-governance",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Our Governance | MH Cockpit - Aviation Training Institute",
    "twitterDescription": "MH Cockpit ensures transparent and quality-driven aviation training governance. Learn about our leadership approach and academic standards.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/about-us/our-values": {
    "title": "Our Values | MH Cockpit - Excellence in Aviation Education",
    "description": "We value excellence, safety, and innovation in aviation education. Explore MH Cockpit's core values and commitment to student success.",
    "keywords": "MH Cockpit values, aviation excellence, safety in aviation, innovation in training, aviation education values",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/about-us/our-values",
    "ogTitle": "Our Values | MH Cockpit - Excellence in Aviation Education",
    "ogDescription": "We value excellence, safety, and innovation in aviation education. Explore MH Cockpit's core values and commitment to student success.",
    "ogUrl": "https://mhcockpit.com/about-us/our-values",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Our Values | MH Cockpit - Excellence in Aviation Education",
    "twitterDescription": "We value excellence, safety, and innovation in aviation education. Explore MH Cockpit's core values and commitment to student success.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/about-us/our-presence": {
    "title": "Our Presence | MH Cockpit Centers Across India",
    "description": "MH Cockpit has a growing presence across India through partnerships with top UGC-approved universities and colleges offering aviation programs.",
    "keywords": "MH Cockpit locations, aviation training centers, Chennai aviation, India aviation training, pilot training centers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/about-us/our-presence",
    "ogTitle": "Our Presence | MH Cockpit Centers Across India",
    "ogDescription": "MH Cockpit has a growing presence across India through partnerships with top UGC-approved universities and colleges offering aviation programs.",
    "ogUrl": "https://mhcockpit.com/about-us/our-presence",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Our Presence | MH Cockpit Centers Across India",
    "twitterDescription": "MH Cockpit has a growing presence across India through partnerships with top UGC-approved universities and colleges offering aviation programs.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/students": {
    "title": "Student Resources | MH Cockpit Aviation Institute",
    "description": "Resources for MH Cockpit students - campus information, DGCA exam preparation, placement support, and student success stories.",
    "keywords": "student resources, MH Cockpit students, campus life, DGCA preparation, placement support, student success",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/students",
    "ogTitle": "Student Resources | MH Cockpit Aviation Institute",
    "ogDescription": "Resources for MH Cockpit students - campus information, DGCA exam preparation, placement support, and student success stories.",
    "ogUrl": "https://mhcockpit.com/students",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Student Resources | MH Cockpit Aviation Institute",
    "twitterDescription": "Resources for MH Cockpit students - campus information, DGCA exam preparation, placement support, and student success stories.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/students/campus": {
    "title": "Student Campus Life | MH Cockpit Aviation Institute",
    "description": "Explore campus life at MH Cockpit - training facilities, simulators, classrooms, and a vibrant aviation student community.",
    "keywords": "campus life, student facilities, aviation training, simulators, MH Cockpit campus",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/students/campus",
    "ogTitle": "Student Campus Life | MH Cockpit Aviation Institute",
    "ogDescription": "Explore campus life at MH Cockpit - training facilities, simulators, classrooms, and a vibrant aviation student community.",
    "ogUrl": "https://mhcockpit.com/students/campus",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Student Campus Life | MH Cockpit Aviation Institute",
    "twitterDescription": "Explore campus life at MH Cockpit - training facilities, simulators, classrooms, and a vibrant aviation student community.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/students/dgca-exams-cleared": {
    "title": "DGCA Exam Success Stories | MH Cockpit Students",
    "description": "MH Cockpit student success stories - DGCA exam clearing, placement achievements, and career milestones in aviation.",
    "keywords": "DGCA exam success, student stories, MH Cockpit achievements, placement success, aviation careers",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/students/dgca-exams-cleared",
    "ogTitle": "DGCA Exam Success Stories | MH Cockpit Students",
    "ogDescription": "MH Cockpit student success stories - DGCA exam clearing, placement achievements, and career milestones in aviation.",
    "ogUrl": "https://mhcockpit.com/students/dgca-exams-cleared",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/Heropage/dgca-cpl-pilot-exam-cleared.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "DGCA Exam Success Stories | MH Cockpit Students",
    "twitterDescription": "MH Cockpit student success stories - DGCA exam clearing, placement achievements, and career milestones in aviation.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/Heropage/dgca-cpl-pilot-exam-cleared.webp"
  },
  "/contact": {
    "title": "Contact Us | MH Cockpit Aviation Training Institute",
    "description": "Get in touch with MH Cockpit for aviation training inquiries, admissions, and partnership opportunities. Our team is here to help.",
    "keywords": "contact MH Cockpit, aviation training inquiries, Chennai aviation contact, pilot training assistance",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/contact",
    "ogTitle": "Contact Us | MH Cockpit Aviation Training Institute",
    "ogDescription": "Get in touch with MH Cockpit for aviation training inquiries, admissions, and partnership opportunities. Our team is here to help.",
    "ogUrl": "https://mhcockpit.com/contact",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Contact Us | MH Cockpit Aviation Training Institute",
    "twitterDescription": "Get in touch with MH Cockpit for aviation training inquiries, admissions, and partnership opportunities. Our team is here to help.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/communication-policy": {
    "title": "Communication Policy | MH Cockpit Aviation Institute",
    "description": "Learn about MH Cockpit's communication policy ensuring clarity, transparency, and effective interactions with students, parents, and partners.",
    "keywords": "communication policy, MH Cockpit communication, student communication, transparent communication",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/communication-policy",
    "ogTitle": "Communication Policy | MH Cockpit Aviation Institute",
    "ogDescription": "Learn about MH Cockpit's communication policy ensuring clarity, transparency, and effective interactions with students, parents, and partners.",
    "ogUrl": "https://mhcockpit.com/communication-policy",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Communication Policy | MH Cockpit Aviation Institute",
    "twitterDescription": "Learn about MH Cockpit's communication policy ensuring clarity, transparency, and effective interactions with students, parents, and partners.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/terms-and-conditions": {
    "title": "Terms and Conditions | MH Cockpit Aviation Institute",
    "description": "Review MH Cockpit's terms and conditions for accessing our aviation training programs, website, and services.",
    "keywords": "terms and conditions, MH Cockpit terms, user agreement, aviation training terms, website terms",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/terms-and-conditions",
    "ogTitle": "Terms and Conditions | MH Cockpit Aviation Institute",
    "ogDescription": "Review MH Cockpit's terms and conditions for accessing our aviation training programs, website, and services.",
    "ogUrl": "https://mhcockpit.com/terms-and-conditions",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Terms and Conditions | MH Cockpit Aviation Institute",
    "twitterDescription": "Review MH Cockpit's terms and conditions for accessing our aviation training programs, website, and services.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/privacy-policy": {
    "title": "Privacy Policy | MH Cockpit Aviation Training Institute",
    "description": "Read MH Cockpit's privacy policy to understand how we collect, store, protect, and use your personal information.",
    "keywords": "privacy policy, data protection, MH Cockpit privacy, information security, user data",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/privacy-policy",
    "ogTitle": "Privacy Policy | MH Cockpit Aviation Training Institute",
    "ogDescription": "Read MH Cockpit's privacy policy to understand how we collect, store, protect, and use your personal information.",
    "ogUrl": "https://mhcockpit.com/privacy-policy",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Privacy Policy | MH Cockpit Aviation Training Institute",
    "twitterDescription": "Read MH Cockpit's privacy policy to understand how we collect, store, protect, and use your personal information.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/mh-cockpit-aviation-training-academy.webp"
  },
  "/for-universities": {
    "title": "For Universities — Launch Aviation Programs | MH Cockpit",
    "description": "Partner with MH Cockpit to launch UGC-compliant aviation courses at your institution. Curriculum, lab setup, faculty support, and employability assistance.",
    "keywords": "aviation programs for universities, UGC aviation courses, university partnership, aviation lab setup, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/for-universities",
    "ogTitle": "For Universities — Launch Aviation Programs | MH Cockpit",
    "ogDescription": "Partner with MH Cockpit to launch UGC-compliant aviation courses at your institution. Curriculum, lab setup, faculty support, and employability assistance.",
    "ogUrl": "https://mhcockpit.com/for-universities",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Home/Converted/Pilots.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "For Universities — Launch Aviation Programs | MH Cockpit",
    "twitterDescription": "Partner with MH Cockpit to launch UGC-compliant aviation courses at your institution.",
    "twitterImage": "https://mhcockpit.com/Media/Home/Converted/Pilots.webp"
  },
  "/consulting": {
    "title": "Aviation Consulting Services | MH Cockpit",
    "description": "MH Cockpit offers aviation consulting services - lab infrastructure, aircraft leasing, financing solutions, and training facility setup.",
    "keywords": "aviation consulting, lab infrastructure, aircraft leasing, financing, training facility, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/consulting",
    "ogTitle": "Aviation Consulting Services | MH Cockpit",
    "ogDescription": "MH Cockpit offers aviation consulting services - lab infrastructure, aircraft leasing, financing solutions, and training facility setup.",
    "ogUrl": "https://mhcockpit.com/consulting",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Consulting/aviation-consulting-services.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Consulting Services | MH Cockpit",
    "twitterDescription": "MH Cockpit offers aviation consulting services - lab infrastructure, aircraft leasing, financing solutions, and training facility setup.",
    "twitterImage": "https://mhcockpit.com/Media/Consulting/aviation-consulting-services.webp"
  },
  "/consulting/lab-infrastructure": {
    "title": "Aviation Lab Infrastructure Consulting | MH Cockpit",
    "description": "MH Cockpit provides lab infrastructure consulting for aviation training - simulators, aircraft systems labs, and maintenance training facilities.",
    "keywords": "lab infrastructure, aviation labs, simulator setup, training facilities, MH Cockpit consulting",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/consulting/lab-infrastructure",
    "ogTitle": "Aviation Lab Infrastructure Consulting | MH Cockpit",
    "ogDescription": "MH Cockpit provides lab infrastructure consulting for aviation training - simulators, aircraft systems labs, and maintenance training facilities.",
    "ogUrl": "https://mhcockpit.com/consulting/lab-infrastructure",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Consulting/lab-infrastructure.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aviation Lab Infrastructure Consulting | MH Cockpit",
    "twitterDescription": "MH Cockpit provides lab infrastructure consulting for aviation training - simulators, aircraft systems labs, and maintenance training facilities.",
    "twitterImage": "https://mhcockpit.com/Media/Consulting/lab-infrastructure.webp"
  },
  "/consulting/aircraft-leasing-and-financing": {
    "title": "Aircraft Leasing & Financing Consulting | MH Cockpit",
    "description": "MH Cockpit provides aircraft leasing and financing consulting services - acquisition, leasing structures, and financial planning for aviation businesses.",
    "keywords": "aircraft leasing, aircraft financing, aviation consulting, leasing structures, MH Cockpit",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/consulting/aircraft-leasing-and-financing",
    "ogTitle": "Aircraft Leasing & Financing Consulting | MH Cockpit",
    "ogDescription": "MH Cockpit provides aircraft leasing and financing consulting services - acquisition, leasing structures, and financial planning for aviation businesses.",
    "ogUrl": "https://mhcockpit.com/consulting/aircraft-leasing-and-financing",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Consulting/aircraft-leasing-and-financing.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Aircraft Leasing & Financing Consulting | MH Cockpit",
    "twitterDescription": "MH Cockpit provides aircraft leasing and financing consulting services - acquisition, leasing structures, and financial planning for aviation businesses.",
    "twitterImage": "https://mhcockpit.com/Media/Consulting/aircraft-leasing-and-financing.webp"
  },
  "/colleges/rathinam-university": {
    "title": "Aviation Courses at Rathinam University Coimbatore",
    "description": "The university offers a structured undergraduate aviation management program for students seeking management and operational careers in the aviation industry.",
    "keywords": "Best Aviation College in Coimbatore, BSc Aviation Coimbatore, BBA in Aviation Coimbatore, aviation courses in Coimbatore, Rathinam University aviation, BSc aviation management, BBA aviation management, aviation colleges in Coimbatore, airport management course Coimbatore, aviation degree after 12th, airline management course, ground handling course, air cargo and logistics course, aviation admission Coimbatore, undergraduate aviation program Tamil Nadu.",
    "robots": "index, follow",
    "canonicalUrl": "https://mhcockpit.com/colleges/rathinam-university",
    "ogTitle": "Best Aviation College in Coimbatore | Rathinam University (BSc & BBA)",
    "ogDescription": "Rathinam University in Coimbatore offers 3-year BSc & BBA in Aviation Management with learning in aircraft systems, flight operations, airport operations, and airline management.",
    "ogUrl": "https://mhcockpit.com/colleges/rathinam-university",
    "ogType": "website",
    "ogSiteName": "MH Cockpit",
    "ogImage": "https://mhcockpit.com/Media/Colleges/rathnam%20campus/aviation-courses-at-rathinam-university.webp",
    "ogImageWidth": 1920,
    "ogImageHeight": 1080,
    "twitterCard": "summary_large_image",
    "twitterTitle": "Best Aviation College in Coimbatore | Rathinam University (BSc & BBA)",
    "twitterDescription": "Rathinam University in Coimbatore offers 3-year BSc & BBA in Aviation Management with learning in aircraft systems, flight operations, airport operations, and airline management.",
    "twitterImage": "https://mhcockpit.com/Media/Colleges/rathnam%20campus/aviation-courses-at-rathinam-university.webp"
  }
};

export default staticMetaDescriptions;
